var $ = require("jquery");
import { gsap, ScrollTrigger } from "./globals.js";

// Hide loader on normal page load
$(document).ready(function () {
    if ($('.loader').hasClass('loader--visible')) {
        gsap.to('.loader', {
            autoAlpha: 0,
            duration: 0.3,
            ease: 'power1.out'
        });
    }

    // Mark that the page was loaded freshly
    sessionStorage.setItem('pageLoaded', 'true');
});

// On link click, show loader and clear marker
$('a:not(.image-enlarge)').on("click", function (e) {
    var link = $(this).attr('href');

    if ($(this).attr('target') === '_blank' || link.startsWith('#')) {
        return;
    }

    e.preventDefault();

    if (link.startsWith('//')) {
        link = window.location.protocol + link;
    }

    const normalizedCurrentURL = window.location.href.split(/[?#]/)[0];
    const normalizedLink = link.split(/[?#]/)[0];

    if (normalizedLink === normalizedCurrentURL) {
        location.reload();
    } else if (this.href.indexOf(window.location.origin) === 0) {
        sessionStorage.removeItem('pageLoaded'); // Mark as not fresh load

        gsap.to('.loader', {
            autoAlpha: 1,
            duration: 0.3,
            ease: 'power1.out'
        });

        setTimeout(() => {
            window.location.href = link;
        }, 550);
    } else {
        window.open(link);
    }
});

// If user navigated back, fade out loader anyway
window.addEventListener('pageshow', function (event) {
    // `persisted` is true if the page was restored from bfcache
    if (event.persisted || !sessionStorage.getItem('pageLoaded')) {
        gsap.to('.loader', {
            autoAlpha: 0,
            duration: 0.3,
            ease: 'power1.out'
        });
    }
});
